import React from 'react';
import { Download } from 'lucide-react';

const TestimonialsSection: React.FC = () => {
  const appStores = [
    {
      name: 'App Store',
      url: 'https://apps.apple.com/app/fitzaa', // Update with actual App Store URL
      description: 'Download on the',
      badgeColor: 'bg-black text-white',
      hoverColor: 'hover:bg-gray-900',
    },
    {
      name: 'Google Play',
      url: 'https://play.google.com/store/apps/details?id=com.pasutech.fitzaa.dev', // Update with actual Play Store URL
      description: 'Get it on',
      badgeColor: 'bg-gradient-to-br from-green-500 to-green-600 text-white',
      hoverColor: 'hover:from-green-600 hover:to-green-700',
    },
  ];

  return (
    <section className="py-20 bg-gray-50 dark:bg-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Download Fitzaa Today
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300">
            Available on iOS and Android
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-8 mb-16">
          {appStores.map((store, index) => (
            <a
              key={index}
              href={store.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`group flex items-center gap-4 px-8 py-6 ${store.badgeColor} ${store.hoverColor} rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 min-w-[240px] transform hover:scale-105`}
            >
              <div className="flex-shrink-0">
                <Download className="w-8 h-8" />
              </div>
              <div className="flex flex-col">
                <p className="text-sm font-medium opacity-90">{store.description}</p>
                <p className="text-xl font-bold">{store.name}</p>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white mb-8">
            Authentic users, Genuine outcomes
          </h3>
          <p className="text-lg text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Fitzaa demonstrates its value, and our client feedback amplifies that message.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;

